var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicesbulbsquaresolid = function SvgIcondevicesbulbsquaresolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/SquareTemplate/icon.devices.bulb.square.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/SquareTemplate/icon.devices.bulb.square.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,79.5 C29.6104084,79.5 32.0018052,78.4527941 34.1741904,76.3583822 L34.1760433,76.3603081 C34.375036,76.1688491 34.3811432,75.8523255 34.1896843,75.6533329 C34.0960616,75.5560263 33.9670619,75.5007241 33.8320312,75.500007 C31.5546875,75.5 29.2773438,75.5 27,75.5 C24.7226562,75.5 22.4453125,75.5 20.1679688,75.5 L20.1679688,75.500007 C19.8918303,75.5014734 19.6691645,75.7265165 19.6706309,76.002655 C19.6713479,76.1376857 19.7266501,76.2666854 19.8239567,76.3603081 C21.9981948,78.4527941 24.3895916,79.5 27,79.5 Z",
    id: "Oval",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,0.5 C34.3180942,0.5 40.9435097,3.44948794 45.7393198,8.21854842 C50.534115,12.9865995 53.5,19.5735337 53.5,26.8494016 C53.5,34.1252694 50.534115,40.7122036 45.7393198,45.4802547 C45.6314416,45.5875313 45.5083201,45.7078017 45.3724224,45.840565 C43.8985796,47.2804138 40.975049,50.1504777 39.5331196,53.8231957 C38.9205071,55.3835723 38.7802006,56.980838 38.6599827,58.4122885 C38.5624442,59.5736935 38.4887495,60.6193789 38.1140216,61.4096239 C37.8692681,61.9257723 37.4811558,62.315483 36.8401556,62.5317528 C36.234841,62.7359825 35.0305341,62.7910709 33.5014251,62.7963284 L32.9133197,62.7961581 C32.2106836,62.7936869 31.4524386,62.7840538 30.6615455,62.775575 C29.487218,62.7629858 28.2421288,62.7496634 26.9964238,62.7585734 C25.9973577,62.7657193 25.0072867,62.7842761 24.0564798,62.8021074 C20.9726715,62.8599406 18.3078217,62.9302274 17.163966,62.5331634 C16.5319016,62.3137564 16.1495056,61.9252865 15.908839,61.4145825 C15.5398779,60.6316327 15.4695191,59.6008779 15.3762663,58.4616151 C15.2569567,57.0040188 15.1166496,55.3794854 14.4592026,53.8124783 C12.8705588,50.025989 10.0031133,47.194982 8.56097001,45.7765909 C3.46994791,40.716202 0.5,34.1282353 0.5,26.8494016 C0.5,19.5735337 3.46588501,12.9865995 8.26068015,8.21854842 C13.0564903,3.44948794 19.6819058,0.5 27,0.5 Z",
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF",
    transform: "translate(27, 31.671) scale(-1, 1) translate(-27, -31.671)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(18, 65.5)",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4,
    x2: 17.5,
    y2: 4,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.0344578e-15,
    y1: 0.5,
    x2: 18,
    y2: 0.5,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 7.5,
    x2: 17,
    y2: 7.5,
    id: "Line-Copy",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicesbulbsquaresolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.bulb.square.solid.91859701a1025362b920fa6e1be0e1d0.svg";